// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8VtQ3","index":"styles_index__39UzM"};